export default "__VITE_ASSET__tViJZkQx__"